import { RouteConfig } from '/@/modules/core/app/helpers/RouteConfig';
import { getters } from '/@/modules/core/app/helpers/store';

export class DocumentBuilderRouteConfig extends RouteConfig {
  /**
   * @returns {boolean}
   */
  canAccessRoute() {
    const authUser = getters.auth.getUser();

    return authUser.permission?.canAccessDocumentBuilder;
  }
}
